import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { QuestionSegmentTypes } from "../../../Schema/getServiceSegments.types";
import { useAppDispatch, useAppSelector } from "../../../Hooks/useStore";
import { useCallback } from "react";

export type InitialStateTypes = {
  activeSegment: QuestionSegmentTypes | null;
};

const initialState = {
  activeSegment: null,
} as InitialStateTypes;

export const activeSegmentSlice = createSlice({
  name: "activeSegmentSlice",
  reducers: {
    setActiveSegment: (state, action: PayloadAction<QuestionSegmentTypes>) => {
      state.activeSegment = action.payload;
    },
  },
  initialState,
});

export const useActiveSegment = () => {
  const dispatch = useAppDispatch();

  const dispatchSetActiveSegment = useCallback(
    (data: QuestionSegmentTypes) => {
      dispatch(setActiveSegment(data));
    },
    [dispatch],
  );

  const { activeSegment } = useAppSelector((state) => state.activeSegment);

  return {
    dispatchSetActiveSegment,
    activeSegment,
  };
};

export const { setActiveSegment } = activeSegmentSlice.actions;
export default activeSegmentSlice.reducer;
